import React, { Component } from 'react'
import { Button, Form, Input, Select, message, Spin, Slider, InputNumber, Table, Tooltip } from 'antd'
import { Link } from 'dva/router'
import NumberFormat from 'react-number-format'
import {connect} from 'dva'
import { all, create, get, update, remove } from '../../services/restApi'
import PropTypes from 'prop-types'
import moment from 'moment'
import config from '../../utils/config'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;

class IntegrationFactor extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
            hotels: [],
            expense_types: [],
            factors: [],
            filterByHotel: '',
            update: false
        }

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        /*if (localStorage.getItem('hotelConta')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};*/

        if (this.props.incomeType === 'cash_funds_trie' || this.props.incomeType === 'others_trie' || this.props.incomeType === 'payroll_trie')
            this.state = {...this.state, currentHotel: null};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {

        // Query Hotel
        let queryHotel = {};
        this.state.currentHotel ? queryHotel.objectId = this.state.currentHotel.objectId : null;

        // Consulta los hoteles
        all('Hotel', {where: queryHotel, limit: 100}).then((resp) => {
            if (this.state.currentHotel) this.props.form.setFieldsValue({hotel: {key: resp.results[0].objectId, label: resp.results[0].name}});
            this.setState({
                hotels: resp.results
            });
        })

        this.firstLoad();
    }


    /**
    * Consulta los registros
    */
    firstLoad () {
        this.props.dispatch({type: 'app/showLoadingTable'})

        all('IntegrationFactor', {limit: 1000}).then((resp) => {
            this.props.dispatch({type: 'app/hideLoadingTable'})

            this.setState({ factors: resp.results });
        })        
    }


    /**
    * Establece el acción para editar
    */
    setUpdate (item) {
        this.setState({ update: true, currentData: item });
        this.props.form.setFieldsValue(item);

        window.scrollTo(0, 0)
    }


    /**
    * Cancela el acción para editar
    */
    cancelUpdate (item) {
        this.setState({ update: false, currentData: null });
        this.props.form.resetFields();
    }


    /**
    * Elimina un registro
    */
    delete_item (item) {
        this.props.dispatch({type: 'app/showLoadingTable'})
        remove('IntegrationFactor', item.objectId).then(() => {

            this.setState({ factors: _.without(this.state.factors, item) });
            this.props.dispatch({type: 'app/hideLoadingTable'})
        });
    }


    /**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            console.log(values);
            if (errors) { return }

            // Model
            let data = {...values};
            data.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId};
            data.year_start = values.years[0];
            data.year_end = values.years[1];
            
            if (!this.state.update) {
                // CREA
                
                this.props.dispatch({type: 'app/showButtonLoading'})
                this.props.dispatch({type: 'app/showLoadingTable'})

                create('IntegrationFactor', data).then(resp => {
                    _.extend(data, resp);

                    var newArray = this.state.factors.slice();
                    newArray.push(data);

                    this.setState({ factors: newArray });

                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    this.props.dispatch({type: 'app/hideLoadingTable'})

                    message.success('Se ha creado el registro exitosamente');
                    this.props.form.resetFields();

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    this.props.dispatch({type: 'app/hideLoadingTable'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                this.props.dispatch({type: 'app/showButtonLoading'})
                this.props.dispatch({type: 'app/showLoadingTable'})

                _.extend(this.state.currentData, data);
                this.state.currentData.year_start = this.state.currentData.years[0];
                this.state.currentData.year_end = this.state.currentData.years[1];

                update('IntegrationFactor', this.state.currentData.objectId, data).then(resp => {

                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    this.props.dispatch({type: 'app/hideLoadingTable'})

                    message.success('Se ha actualizado el registro exitosamente');
                    this.props.form.resetFields();

                    this.setState({ update: false });

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    this.props.dispatch({type: 'app/hideLoadingTable'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });
            }
        })
    }


    /**
    * Render del componente
    */
    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <Form onSubmit={this.handleSubmit.bind(this)}>
                <div className={`row ${this.state.update ? " ant-alert-warning " : ""}`} style={{padding: '15px 0'}}>
                    {this.state.update
                        ? <div className="col-md-12 marginBottom20" style={{ fontSize: '15px', color: '#ffbf00' }}>
                            <Icon name="exclamation-circle" /> Usted está editando el registro
                        </div>
                        : ''
                    }

                    <div className="col-md-2">
                        <FormItem label="Años de Servicio">
                            {this.props.form.getFieldDecorator('years', {
                                initialValue: [1, 50],
                                rules: [{
                                    required: true,
                                    message: 'Por favor, elija el rango de días que corresponden al factor'
                                }]
                            })(
                                <Slider 
                                    range 
                                    min={1}
                                    max={50}
                                    marks={{1: '1 días', 50: '50 días'}} />
                            )}
                        </FormItem>
                    </div>

                    <div className="col-md-2">
                        <FormItem label="Días de Aguinaldo" hasFeedback>
                            {this.props.form.getFieldDecorator('bonus_days', {
                                initialValue: 15,
                                rules: [{
                                    required: true,
                                    message: 'Por favor, ingrese los días de aguinaldo'
                                }]
                            })(
                                <InputNumber min={1} max={50} className="ant-input ant-input-lg" />
                            )}
                        </FormItem>
                    </div>

                    <div className="col-md-2">
                        <FormItem label="Días de Vacaciones" hasFeedback>
                            {this.props.form.getFieldDecorator('vacations_days', {
                                initialValue: 6,
                                rules: [{
                                    required: true,
                                    message: 'Por favor, ingrese los días de vacaciones'
                                }]
                            })(
                                <InputNumber min={1} max={50} className="ant-input ant-input-lg" />
                            )}
                        </FormItem>
                    </div>

                    <div className="col-md-2">
                        <FormItem label="Prima Vacacional" hasFeedback>
                            {this.props.form.getFieldDecorator('vacations_percent', {
                                initialValue: 25,
                                rules: [{
                                    required: true,
                                    message: 'Por favor, ingrese la prima vacacional'
                                }]
                            })(
                                <InputNumber 
                                    min={1} 
                                    max={100} 
                                    formatter={value => `${value}%`}
                                    parser={value => value.replace('%', '')} 
                                    className="ant-input ant-input-lg" />
                            )}
                        </FormItem>
                    </div>

                    <div className="col-md-2">
                        <FormItem label="Factor de Integración" hasFeedback>
                            {this.props.form.getFieldDecorator('integration_factor', {
                                initialValue: 1.0452,
                                rules: [{
                                    required: true,
                                    message: 'Por favor, ingrese el factor de integración'
                                }]
                            })(
                                <InputNumber min={1} max={10} step={0.01} className="ant-input ant-input-lg" />
                            )}
                        </FormItem>
                    </div>

                    <div className="col-md-2" style={{marginTop: 40}}>
                        <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                            <Icon name="save" /> Guardar
                        </Button>

                        {this.state.update
                            ? <Button type='danger' onClick={this.cancelUpdate.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat marginTop10'}>
                                <Icon name="ban" /> Cancelar
                            </Button>
                            : ''
                        }
                    </div>
                </div>

                <div className="row marginTop20">
                    <Spin spinning={this.props.app.loadingTable}>
                        <div className="col-md-12">
                            <Table 
                                dataSource={this.state.factors} 
                                rowKey="objectId" 
                                size="middle" 
                                pagination={false}
                                scroll={{ y: 300 }} >

                                <Column title="Años de servicio" key="years" render={(item) => (
                                    <span>{item.years[0]} - {item.years[1]} días</span>
                                )}/>

                                <Column title="Días de Aguinaldo" key="bonus_days" render={(item) => (
                                    <span>{item.bonus_days}</span>
                                )}/>

                                <Column title="Días de Vacaciones" key="vacations_days" render={(item) => (
                                    <span>{item.vacations_days}</span>
                                )}/>

                                <Column title="Prima Vacacional" key="vacations_percent" render={(item) => (
                                    <span>{item.vacations_percent}</span>
                                )}/>

                                <Column title="Factor de Integación" key="integration_factor" render={(item) => (
                                    <span>{item.integration_factor}</span>
                                )}/>

                                <Column title="Acciones" key="action" width={90}
                                    render={(item) => (
                                        <span className="actions">
                                            <ButtonGroup>
                                                <Tooltip placement="bottom" title="Editar">
                                                    <Button>
                                                        <Link onClick={() => { this.setUpdate(item) }}><Icon name="edit" /></Link>
                                                    </Button>
                                                </Tooltip>

                                                <Tooltip placement="bottom" title="Eliminar">
                                                    <Button>
                                                        <Link onClick={() => { this.delete_item(item) }} className=""><Icon name="trash" /></Link>
                                                    </Button>
                                                </Tooltip>
                                            </ButtonGroup>
                                        </span>
                                    )}
                                />
                            </Table>  
                        </div>
                    </Spin>
                </div>
            </Form>
        )
    }
}

IntegrationFactor.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({income, app}) => ({income, app}))(Form.create()(IntegrationFactor))


// WEBPACK FOOTER //
// ./src/components/config/integrationFactor.js